import script from "./CouponsPerHour.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponsPerHour.vue?vue&type=script&setup=true&lang=js"

import "./CouponsPerHour.vue?vue&type=style&index=0&id=4a9a36be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9a36be"]])

export default __exports__